const routes = {
    authentication: {
        login: { template: '/login', build: () => `/login` },
        registration: { template: '/register', build: () => `/register` },
        forgot: { template: '/forgot', build: () => `/forgot` },
        reset: { template: '/reset', build: () => `/reset` },
    },
    app: {
        gettingStarted: { template: '/getting-started', build: () => `/getting-started` },
        profilePage: { template: '/profile', build: () => `/profile` },
        finish: { template: '/finish', build: () => `/finish` },
        matches: { template: '/matches', build: () => `/matches` },
        matchDetails: { template: '/matches/:matchId', build: (matchId: string) => `/matches/${matchId}` },
        profile: {
            searchPreferences: { key: 'SearchPreferences', template: '/profile/search-preferences', build: () => `/profile/search-preferences` },
            //importantFactors: { key: 'ImportantFactors', template: '/profile/important-factors', build: () => `/profile/important-factors` },
            personalProfile: { key: 'PersonalProfile', template: '/profile/personal', build: () => `/profile/personal` },
            //profileDetails: { key: 'ProfileDetails', template: '/profile/details', build: () => `/profile/details` },
            searchPosts: { key: 'SearchPosts', template: '/profile/search-posts', build: () => `/profile/search-posts` },
            telegramRegistration: { key: 'TelegramRegistration', template: '/profile/telegram', build: () => `/profile/telegram` },
            emailNotification: { key: 'EmailNotification', template: '/profile/email', build: () => `/profile/email` },
            subscriptionManagement: { key: 'SubscriptionManagement', template: '/profile/subscription', build: () => `/profile/subscription` },
        },
        publicProfile: { template: '/public-profile', build: (profileKey: string) => `/public-profile?user=${profileKey}` },
    },
    homepage: {
        privacyPolicy: { template: '/privacy-policy', build: () => `/privacy-policy` },
        termsOfService: { template: '/terms-of-service', build: () => `/terms-of-service` },
    }
} as const;

export default routes;